import L from 'leaflet';
// Leaflet's default marker images break under webpack bundling (relative paths),
// making placed markers invisible. Re-point them to the CDN assets.
// Imported for its side effect by every component that shows a default marker.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});
